import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ReorderDossierTasksController::__invoke
* @see app/Http/Controllers/Dossier/ReorderDossierTasksController.php
* @route '/api/dossier/{dossier}/tasks/reorder'
*/
const ReorderDossierTasksController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderDossierTasksController.url(args, options),
    method: 'put',
})

ReorderDossierTasksController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/tasks/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\ReorderDossierTasksController::__invoke
* @see app/Http/Controllers/Dossier/ReorderDossierTasksController.php
* @route '/api/dossier/{dossier}/tasks/reorder'
*/
ReorderDossierTasksController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return ReorderDossierTasksController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ReorderDossierTasksController::__invoke
* @see app/Http/Controllers/Dossier/ReorderDossierTasksController.php
* @route '/api/dossier/{dossier}/tasks/reorder'
*/
ReorderDossierTasksController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderDossierTasksController.url(args, options),
    method: 'put',
})

export default ReorderDossierTasksController